<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle1"><a id="page_vii"></a><a id="cont"></a>CONTENTS</h1>
<p class="toc0"><a href="#/06_introduction#intro">Introduction</a></p>
<p class="toc1"><a href="#/07_chapter01#c01"><span class="small">CHAPTER</span> 1.   History</a></p>
<p class="toc1"><span href="#/08_chapter02#c02" title="Link target outside of Sample"><span class="small">CHAPTER</span> 2.   The Gods</span></p>
<p class="toc1"><span href="#/09_chapter03#c03" title="Link target outside of Sample"><span class="small">CHAPTER</span> 3.   Other Beings</span></p>
<p class="toc1"><span href="#/10_chapter04#c04" title="Link target outside of Sample"><span class="small">CHAPTER</span> 4.   Beliefs and Morality</span></p>
<p class="toc1"><span href="#/11_chapter05#c05" title="Link target outside of Sample"><span class="small">CHAPTER</span> 5.   Rituals</span></p>
<p class="toc1"><span href="#/12_chapter06#c06" title="Link target outside of Sample"><span class="small">CHAPTER</span> 6.   Holiday Calendar</span></p>
<p class="toc1"><span href="#/13_chapter07#c07" title="Link target outside of Sample"><span class="small">CHAPTER</span> 7.   The Three Kinds of Magic</span></p>
<p class="toc0"><span href="#/14_resources#resou" title="Link target outside of Sample">Resources</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?422c2187